export enum CookieValues {
  Ga = '_ga',
  YmUID = '_ym_uid',
}
